<div class="slider {{ classes }} {{ internalClasses }}">
    <div class="line"></div>
    <div class="subline inc"></div>
    <div class="subline dec"></div>
</div>
